<template>
	<el-row v-bind="{gutter, justify, align, type}" :class="[rowClasses, {'frm-row': isFormMode, 'frm-row-noflex': !flex}]">
		<slot />
	</el-row>
</template>

<script>
import Vue from 'vue';
import { PageModeUtils } from '@/main/utils/pageMode';
import { EventBus } from '@/main/eventBus';

export default Vue.extend({
	name: 'DmsRow',
	props: {
		gutter: { type: Number, required: false, default: 10 },
		rowClasses: { type: String, required: false },
		align: { type: String },
		justify: { type: String },
		type: { type: String, required: false },
		flex: { type: Boolean, default: true },
	},
	data() {
		return { Mode: null };
	},
	computed: {
		pageMode() {
			return PageModeUtils.getModeByDefaultView(this.Mode);
		},
		isFormMode() {
			return (
				PageModeUtils.isCreate(this.pageMode)
				|| PageModeUtils.isView(this.pageMode)
				|| PageModeUtils.isEdit(this.pageMode)
			);
		},
	},
	created() {
		EventBus.$on('Mode', this.onModeChanged);
	},
	beforeDestroy() {
		EventBus.$off('Mode', this.onModeChanged);
	},
	methods: {
		onModeChanged(mode) {
			this.Mode = mode;
		},
	},
});
</script>
